{
  "#MDE_STOCKPOSTING": {
    "DIALOG": {
      "HEADER_TEXT": {
        "ACTION_TITLE": "Kopftext bearbeiten"
      },
      "SIGNATURE": {
        "ACTION_TITLE": "Unterschrift",
        "TITLE": "Unterschrift",
        "SUB_TITLE": "Bitte unterschreiben Sie im Feld darunter und geben sie Ihren Namen ein",
        "PLACEHOLDER": "Name des Unterzeichners"
      },
      "PICTURE_UPLOAD": {
        "ACTION_TITLE": "Fotos hochladen",
        "TITLE": "Fotos hochladen"
      },
      "DOCUMENT_UPLOAD": {
        "ACTION_TITLE": "Dokument hinzufügen",
        "TITLE": "Dokument hinzufügen"
      }
    },
    "ACTION": {
      "DELETE_ARTICLE": "Artikel löschen",
      "DELETE_BELEG": "Beleg löschen",
      "FINISH": "Abschließen"
    },
    "TABLE": {
      "MENGE": "Menge",
      "ITEM_NR": "Artikel-Nr.",
      "DESC": "Beschreibung",
      "ROW_TEXT": "Zeilentext",
      "PHOTOS": "Fotos",
      "ACCOUNT": "Sachkonto",
      "COST_CENTER": "Kostenstelle",
      "STORAGE": "Lagerplatz",
      "ACTION": "Bearbeiten"
    }
  }
}
